enum Action {
  SET_PAYLOAD = 'setTooltipPayload',
  CLEAR_PAYLOAD = 'clearTooltipPayload',
}

export default Action;
